<template>
  <v-container id="prices" tag="section" class="mb-4">
    <base-subheading>Prices</base-subheading>

    <v-card flat>
      <v-card-text class="text-subtitle-1"
        >Every mount is unique and tailored to your vision.</v-card-text
      >
      <v-card-text class="mt-4 text-center">
        <v-btn
          class="primary"
          :block="$vuetify.breakpoint.smAndDown"
          elevation="2"
          @click="openEmail"
          >Click Here for a Free Quote</v-btn
        >
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Prices",
  components: {
    // PriceList: () => import("./prices/PriceList"),
  },
  data() {
    return {
      prices: [
        { name: "Whitetail Deer", price: "750", type: "Land" },
        { name: "Elk Shoulder", price: "1300", type: "Land" },
        { name: "Antelope", price: "750", type: "Land" },
        { name: "Mule Deer", price: "750", type: "Land" },
        { name: "Coyote", price: "1000", type: "Land" },
        { name: "Fox", price: "950", type: "Land" },
        { name: "Bobcat", price: "950", type: "Land" },
        { name: "Raccoon", price: "950", type: "Land" },
        { name: "Squirrel", price: "450", type: "Land" },
        { name: "Mink", price: "500", type: "Land" },
        { name: "Muskrat", price: "500", type: "Land" },
        { name: "Otter", price: "950", type: "Land" },
        { name: "Mergansers", price: "425", type: "Waterfowl" },
        { name: "Puddle / Diving Ducks", price: "400", type: "Waterfowl" },
        {
          name: "Puddle / Diving Ducks (3 month turnaround)",
          price: "850",
          type: "Waterfowl",
        },
        { name: "Sea Ducks", price: "425", type: "Waterfowl" },
        { name: "Pheasant", price: "400", type: "Waterfowl" },
        { name: "Canadian Goose", price: "900", type: "Waterfowl" },
        { name: "Swan", price: "1200", type: "Waterfowl" },
        { name: "Specks/Snows", price: "600", type: "Waterfowl" },
        { name: "Quail", price: "425", type: "Waterfowl" },
        { name: "Chukar", price: "400", type: "Waterfowl" },
        { name: "Grouse", price: "400", type: "Waterfowl" },
        { name: "Wood-Cock", price: "450", type: "Waterfowl" },
        { name: "Morning Dove", price: "475", type: "Waterfowl" },
        { name: "Pigeon", price: "400", type: "Waterfowl" },
        { name: "Turkey", price: "1200", type: "Waterfowl" },
        { name: "Turkey Fan, Beard & Spurs", price: "200", type: "Waterfowl" },
        {
          name: "Turkey Fan, Wings, Beard & Spurs",
          price: "500",
          type: "Waterfowl",
        },
        {
          name: "Turkey Rug, Back Skin, Tail Fin, Beard & Spurs",
          price: "800",
          type: "Waterfowl",
        },
        { name: "Turkey Shoulder Mount", price: "800", type: "Waterfowl" },
      ],
    };
  },
  computed: {
    ...mapGetters(["emailContact", "phoneContact"]),
    landPrices() {
      return this.prices.filter((i) => i.type === "Land");
    },
    waterfowlPrices() {
      return this.prices.filter((i) => i.type === "Waterfowl");
    },
  },
  methods: {
    openEmail() {
      window.open(this.emailContact.url);
    },
  },
};
</script>

<style scoped>
.v-card__text {
  padding: 0 !important;
}
.v-expansion-panel-content {
  padding: 0 !important;
}
</style>
